import {
    Button,
    Grid,
    Typography,
    Container,
    Dialog,
    Divider,
    DialogActions,
    DialogContent,
    FormControl,
    TextField,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    TableCell,
    TableRow,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { useTranslation } from "react-i18next";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { tr } from "date-fns/esm/locale";
import { Delete } from "@mui/icons-material";
import CustomFabButton from "../../components/Button/CustomFabButton";
import GenericDatePicker from "../GenericDatePicker/GenericDatePicker";

const useStyles = makeStyles((theme) => ({
    popupElement: {
        width: "80%",
        marginLeft: 20,
    },
    label: {
        margin: 20,
        alignSelf: "center",
    },
}));

export default function UnplannedMaintenaceOfTheReportsPopup(props) {
    const { t } = useTranslation("translation");
    const classes = useStyles();
    const EmptyRow = () => {
        return (
            <Grid item xs={12} style={{ margin: 25 }}>
                <Grid item xs>
                    <Divider />
                </Grid>
            </Grid>
        );
    };
    return (
        <div>
            <Container>
                <Dialog open={props.handleOpen} onClose={props.handleCancel} fullWidth="xs">
                    <DialogContent>
                        <form>
                            <Grid container>
                                {props.unplannedMaintenanceOfTheReport.length > 0 ? (
                                    <>
                                        <Accordion style={{width: "100%"}} >
                                            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                                                <Typography variant="h6" component="h6">
                                                    {t("PreviousReport")}
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                {props.unplannedMaintenanceOfTheReport.map((detailRow, itemIndex) => (
                                                    <TableRow id={`upmotr_TableRow_${itemIndex}`} key={detailRow.id}>
                                                        <TableCell id={`upmotr_TableCell_subName`} style={{width: "100%"}}>
                                                            {detailRow.note.length >= 50 ? detailRow.note.slice(0, 50) + "..." : detailRow.note}
                                                        </TableCell>
                                                        <TableCell id={`upmotr_TableCell_button`} align="center" style={{width: "100%"}}>
                                                        <CustomFabButton
                                                            id={`upmotr_TableRow_Delete_${itemIndex}`}
                                                            title={t("Delete")}
                                                            onClick={() => props.deleteReportsButtonHandler(detailRow)}
                                                            icon={<Delete />}
                                                            color="secondary"
                                                            aria-label="delete"
                                                            style={{ marginRight: 5 }}
                                                        />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </AccordionDetails>
                                        </Accordion>
                                        <EmptyRow />
                                    </>
                                 ) : null}
                                <Grid item xs={3}>
                                    <FormControl className={classes.label}>
                                        <Typography variant="h6" component="h6">
                                            {t("Start")}
                                        </Typography>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={9}>
                                    <FormControl variant="outlined" className={classes.popupElement}>
                                        <LocalizationProvider id="LocalizationProvider_1" dateAdapter={AdapterDateFns} locale={tr}>
                                            <GenericDatePicker
                                                id="upmotr_table_DatePicker_12"
                                                dateValue={props.startDate}
                                                minDate={props.minDate}
                                                maxDate={props.maxDate}
                                                onDateChange={props.onStartDateChangeHandler}
                                                readOnly={true}
                                                label={t("StartDate")}
                                                error={
                                                    !props.startDate
                                                        ? props.errorReports.dateSelectedText
                                                        : props.errorReports.dateMinText
                                                        ? props.errorReports.dateMinText
                                                        : props.errorReports.dateMaxText
                                                        ? props.errorReports.dateMaxText
                                                        : props.errorReports.startDateMinText
                                                        ? props.errorReports.startDateMinText
                                                        : false
                                                }
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                </Grid>
                                <EmptyRow />
                                <Grid item xs={3}>
                                    <FormControl className={classes.label}>
                                        <Typography variant="h6" component="h6">
                                            {t("End")}
                                        </Typography>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={9}>
                                    <FormControl variant="outlined" className={classes.popupElement}>
                                        <LocalizationProvider id="LocalizationProvider_1" dateAdapter={AdapterDateFns} locale={tr}>
                                            <GenericDatePicker
                                                id="upmotr_table_DatePicker_13"
                                                dateValue={props.endDate}
                                                minDate={props.minDate}
                                                maxDate={props.maxDate}
                                                onDateChange={props.onEndDateChangeHandler}
                                                readOnly={true}
                                                label={t("EndDate")}
                                                error={
                                                    !props.endDate
                                                        ? props.errorReports.dateSelectedText
                                                        : props.errorReports.dateMaxText
                                                        ? props.errorReports.dateMaxText
                                                        : props.errorReports.dateMinText
                                                        ? props.errorReports.dateMinText
                                                        : props.errorReports.endDateMaxText
                                                        ? props.errorReports.endDateMaxText
                                                        : false
                                                }
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                </Grid>
                                <EmptyRow />
                                <Grid item xs={12}>
                                    <TextField
                                        id="note"
                                        label={t("Note")}
                                        variant="outlined"
                                        onChange={props.onNoteChangeHandler}
                                        fullWidth
                                        error={props.errorReports.noteText.length > 0}
                                        helperText={props.errorReports.noteText}
                                    />
                                </Grid>
                            </Grid>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button id="Cancel_Button" onClick={props.handleCancel} color="primary">
                            {t("Cancel")}
                        </Button>
                        <Button id="Confirm_Button" onClick={props.handleClose} color="primary" disabled={props.isReportsButtonDisable}>
                            {t("Confirm")}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Container>
        </div>
    );
}
